import React, { useState } from "react";
import './PDFSelector.css'; // Adjust the path as needed

// Define categories and their corresponding PDFs
const categories = {
  "MGNREGS": ["MGNREGA_Act.pdf", "Annual Master Circular 2024-25.pdf","Modification_AMC 2024-25.pdf","Operational_Guidelines_4thEdition_Eng_2013.pdf"],
  "NSAP": ["NSAP Guidelines.pdf", ],
  "PMAY-G": ["PMAY_G Social Audit Guidelines.pdf",],
  "SOCIAL AUDIT": ["Auditing Standards of MoRD.pdf", "MGNREGS Audit of Scheme Rules 2011.pdf","Social Audit Manual with Letter.pdf","VRP Traning Manual.pdf"],
  "OTHERS": ["",],
};

function PDFSelector() {
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedPDF, setSelectedPDF] = useState("");

  // Handle category selection
  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
    setSelectedPDF(""); // Reset selected PDF when category changes
  };

  // Handle PDF selection
  const handlePDFChange = (event) => {
    setSelectedPDF(event.target.value);
  };

  // Handle form submission
  const handleSubmit = (event) => {
    event.preventDefault();
    if (selectedPDF) {
      // Open the selected PDF in a new tab
      window.open(`${process.env.PUBLIC_URL}/New folder/${selectedCategory.toLowerCase().replace(/ /g, "")}/${selectedPDF}`, "_blank");
    } else {
      alert("Please select a PDF to open.");
    }
  };

  return (
    <div className="pdf-selector">
      <h2>Select a Category:</h2>
      <form onSubmit={handleSubmit}>
        {/* Category Dropdown */}
        <select onChange={handleCategoryChange} value={selectedCategory} required>
          <option value="" disabled>Select Category</option>
          {Object.keys(categories).map((category) => (
            <option key={category} value={category}>
              {category}
            </option>
          ))}
        </select>

        {/* PDF Dropdown */}
        {selectedCategory && (
          <div style={{ marginTop: "20px" }}>
            <h3>Available PDFs in {selectedCategory}:</h3>
            <select onChange={handlePDFChange} value={selectedPDF} required>
              <option value="" disabled>Select PDF</option>
              {categories[selectedCategory].map((pdf) => (
                <option key={pdf} value={pdf}>
                  {pdf}
                </option>
              ))}
            </select>
          </div>
        )}
        {/* Submit Button */}
        <button className="button" type="submit">
          Open PDF
        </button>
      </form>
    </div>
  );
}

export default PDFSelector;
